<template>
  <error-page :code="$route.params.type"></error-page>
</template>

<script>
import ErrorPage from '@/components/ErrorPage'

export default {
  name: 'Error',
  components: {
    ErrorPage
  }
}
</script>
